var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { BenefitCardMW, BenefitCardFullWidthDTW, BenefitCardHalfWidthDTW, } from '../../../shared/rewards-hub';
import { getImageURL } from '../../../../utils/GeneralUtil';
var constants = {
    title: "Exclusive Savings & Events",
    headline: "",
    subtitle: "Take advantage of early access to sales and promotions during in-store and online events",
    iconUrl: getImageURL("WelcomeCard/active_Exclusive_S&E.svg"),
};
var ExclusiveSavingsMW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, title: constants.title, iconUrl: constants.iconUrl, headline: isLocked ? constants.headline : undefined, subtitle: constants.subtitle });
    return React.createElement(BenefitCardMW, __assign({}, data));
};
var ExclusiveSavingsFullWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, title: constants.title, iconUrl: constants.iconUrl, headline: isLocked ? constants.headline : undefined, subtitle: constants.subtitle });
    return React.createElement(BenefitCardFullWidthDTW, __assign({}, data));
};
var ExclusiveSavingsHalfWidthDTW = function (props) {
    var isLocked = props.isLocked;
    var data = __assign(__assign({}, props), { isLocked: isLocked, title: constants.title, headline: isLocked ? constants.headline : undefined, subtitle: constants.subtitle, iconUrl: constants.iconUrl });
    return React.createElement(BenefitCardHalfWidthDTW, __assign({}, data));
};
export var ExclusiveSavings = function (_a) {
    var isMobile = _a.isMobile, isLocked = _a.isLocked;
    var data = { isMobile: isMobile, isLocked: isLocked };
    return isMobile ? (React.createElement(ExclusiveSavingsMW, __assign({}, data))) : (React.createElement(ExclusiveSavingsFullWidthDTW, __assign({}, data)));
};
